<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';

const props = defineProps<{
  propertyCount: number
  to: RouteLocationRaw
  pending?: boolean
}>();

const open = defineModel<boolean>('open', { default: false });

const emit = defineEmits<{
  alert: []
}>();

const hasNoResults = computed(() => {
  return props.propertyCount === 0 && !props.pending;
});
</script>

<template>
  <div>
    <template v-if="hasNoResults">
      <p class="flex gap-xs mb-xs">
        <Icon
          name="iad-icon:lightbulb"
          class="flex-none size-l"
        />
        <span
          class="flex-1 font-semibold"
          v-text="$t(`property_serp.no_ad_found_for_criteria`)"
        />
      </p>
      <IadBtn
        class="w-full"
        @click="emit('alert')"
      >
        <Icon name="iad-icon:notifications" />
        {{ $t(`property_serp.notification.create_alert`) }}
      </IadBtn>
    </template>
    <IadBtn
      v-else
      class="w-full"
      :to
      @click="open = false"
    >
      <Icon name="iad-icon:search" />
      {{ pending ? $t(`core.common.search`) : $t(`property_serp.filters.apply`, { count: propertyCount, propertyCount: $n(propertyCount) }) }}
    </IadBtn>
  </div>
</template>
